var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLanguage = function SvgLanguage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 12c0-4.982-4.018-9-9-9s-9 4.018-9 9m18 0c0 4.982-4.018 9-9 9s-9-4.018-9-9m18 0H3m7.168-7.94c-2.89 4.825-2.89 11.056 0 15.881a2.114 2.114 0 0 0 3.665 0c2.89-4.825 2.89-11.056 0-15.881a2.114 2.114 0 0 0-3.665 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLanguage);
export default ForwardRef;